export default "__VITE_ASSET__Db2JW6pD__"